<template>
  <div class="eval">
    <div class="eval_title">
      <span>{{ $t('eval_submit') }}</span>
      <span class="eval_close" @click="close()"></span>
    </div>
    <div class="eval_body" v-if="connectStatus === 'robot'">
      <p class="eval_desc">{{ $t('eval_desc') }}</p>
      <div class="row">
        <div :class="type ? 'item good active' : 'item good'" @click="chooseType(1)"
          :style="{ backgroundColor: (type ? '#00A1E2' : 'white') }">
          <span class="eval_icon "></span>
          {{ $t('solved') }}
        </div>
        <div :class="type ? 'item bad' : 'item bad active'"
          :style="{ backgroundColor: (!type ? '#00A1E2' : 'white') }" @click="chooseType(0)">

          <span class="eval_icon "></span>
          {{ $t('noSolved') }}
        </div>
      </div>
      <p class="eval_desc"></p>
      <textarea v-model="suggester"  :placeholder="$t('leaveInput')" onresize="false"></textarea>
      <Button @click="submitEvaluate" :style="{ background: `#00A1E2` }"  type="default" size="normal">{{ $t('submit')
}}</Button>
    </div>
    <div class="eval_body manual" v-if="connectStatus === 'manual'">
      <div class="row" style="margin-top: 20px">
        <div :class="type ? 'item good active' : 'item good'"
          :style="{ backgroundColor: (type ? '#00A1E2' : 'white') }" @click="chooseType(1)">
          <span class="eval_icon "></span>
          {{ $t('solved') }}
        </div>
        <div :class="type ? 'item bad' : 'item bad active'"
          :style="{ backgroundColor: (!type ? '#00A1E2' : 'white') }" @click="chooseType(0)">
          <span class="eval_icon "></span>
          {{ $t('noSolved') }}
        </div>
      </div>
      <div class="row">
        <div class="star_list">
                            <!-- <span :class="star >= 1 ? 'star active':'star'" @click="chooseStar(1)"></span>
              <span :class="star >= 2 ? 'star active':'star'" @click="chooseStar(2)"></span>
              <span :class="star >= 3 ? 'star active':'star'" @click="chooseStar(3)"></span>
              <span :class="star >= 4 ? 'star active':'star'" @click="chooseStar(4)"></span>
              <span :class="star === 5 ? 'star active':'star'" @click="chooseStar(5)"></span> -->

                            <!-- <span  @click="chooseStar(1)">   
                 <img v-if="star==1" src="../../../static/image/npsFeel1.png" alt="" srcset="">
                <img v-if="star!=1" src="../../../static/image/npsFeelGrey1.png" alt="" srcset=""></span> -->
                            <span  class="plf20" @click="chooseStar(2)">
                                <img width="60"  v-if="star == 2" src="../../../static/image/frown.png" alt="" srcset="" />
                                <img width="60"  v-if="star != 2" src="../../../static/image/frown2.png" alt=""
                                    srcset="" /></span>
                            <!-- <span  @click="chooseStar(3)">   
                <img v-if="star==3" src="../../../static/image/npsFeel3.png" alt="" srcset="">
                <img v-if="star!=3" src="../../../static/image/npsFeelGrey3.png" alt="" srcset=""></span> -->
                            <span  class="plf20" @click="chooseStar(4)">
                                <img  width="60" v-if="star == 4" src="../../../static/image/meh.png" alt="" srcset="" />
                                <img width="60"  v-if="star != 4" src="../../../static/image/meh2.png" alt="" srcset="" />
                            </span>
                            <span  class="plf20" @click="chooseStar(5)">
                                <img width="60"  v-if="star == 5" src="../../../static/image/smile.png" alt="" srcset="" />
                                <img width="60"  v-if="star != 5" src="../../../static/image/smile2.png" alt="" srcset="" />
                            </span>
                        </div>
      </div>
      <div v-if="evaluateData.starList">
        <p :style="{ color: initData.kitBgcolor }">
          {{ evaluateData.starList[star - 1].levelDescription }}
        </p>
      </div>
      <div class="row1" v-if="evaluateData.starList">
        <div v-for="(target, index) in evaluateData.starList[star - 1].select" v-if="target.name"
          :key="target.name + Math.random() * 100"
          :style="{ backgroundColor: (target.value ? '#00A1E2' : 'white'), color: (target.value ? 'white' : '#00A1E2') }"
          class="item2" @click="chooseAdvice(target)">
          {{ target.name }}
        </div>
      </div>
      <textarea  v-model="suggester"  :placeholder="$t('leaveInput')"
        onresize="false"></textarea>
      <Button @click="submitEvaluate" :style="{ background: `#00A1E2` }"
        type="default" size="normal">{{ $t('submit')
        }}</Button>
    </div>
  </div>
</template>

<script>
import { Button } from 'mint-ui';
import language from "../../store";
import chatApi from "../methods";
export default {
  name: "evaluate",
  data() {
    return {
      type: 1, // 机器人是否解决
      star: 5,// 默认5分
      suggestion: [
        { name: this.$t('robotEva1'), value: 0 },
        { name: this.$t('robotEva2'), value: 0 },
        { name: this.$t('robotEva3'), value: 0 },
        { name: this.$t('robotEva4'), value: 0 }
      ],
      advice: [
        { name: this.$t('customerEva1'), value: 0 },
        { name: this.$t('customerEva2'), value: 0 },
        { name: this.$t('customerEva3'), value: 0 },
        { name: this.$t('customerEva4'), value: 0 }
      ],
      suggester: '',
    }
  },
  mounted() {
      console.log('评价')
  },
  components: {
    Button
  },
  computed: {
    connectStatus() {
      return this.$store.state.connectStatus
    },
    evaluateData() {
      return this.$store.state.evaluateData;
    },
    initData() {
      return this.$store.state.initData;
    },
  },
  watch: {
    connectStatus() {
      return this.$store.state.connectStatus
    },
    evaluateData() {
      return this.$store.state.evaluateData;
    },

  },
  methods: {
    // 选中建议
    chooseSuggestion(index) {
      this.suggestion[index].value = !this.suggestion[index].value;
    },
    // 人工建议
    chooseAdvice(obj) {
      obj.value = !obj.value;
      // this.advice[index].value = !this.advice[index].value;
    },
    // 更改评分
    chooseStar(star) {
      this.star = star;
      this.advice.forEach(sug => {
        sug.value = 0
      })
      this.suggester = '';
    },
    chooseType(type) {
      this.type = type
    },
    close() {
      this.$emit('closePopup')
    },
    submitEvaluate() {
      let param = {};
      if (this.$store.state.connectStatus === "robot") {
        let arr = [];
        this.suggestion.forEach((sug) => {
          if (sug.value) {
            arr.push(sug.name);
          }
        });
        param.evaluateRobotTag = arr.join(",");
        param.evaluateRobotSolve = this.type;
        param.evaluateRobotMode = 1;
        param.evaluateRobotContent = this.suggester; //评价客服内容，长度最大64
      } else if(this.evaluateData.starList) {
        let arr = [];
        this.evaluateData.starList[this.star - 1].select.forEach((item) => {
          if (item.value) {
            arr.push(item.name);
          }
        });
        if (this.evaluateData.starList[this.star - 1].evaluateMsgRequired && !this.suggester) {
          // 必填评价
          Toast({
            message: this.$t("evaConInput"),
            duration: 3000,
          });
          return;
        }
        if (this.evaluateData.starList[this.star - 1].levelTagRequired && arr.length === 0) {
          // 必填评价
          Toast({
            message: this.$t("evaLabelSelect"),
            duration: 3000,
          });
          return;
        }
        param.evaluateAdminSolve = this.type;
        param.evaluateAdminMode = 1;
        param.evaluateAdminContent = this.suggester; //评价客服内容，长度最大64
        param.evaluateAdminStar = this.star; //客服评价星级
        param.evaluateAdminTag = arr.join(","); //客服评价标签，多个逗号分隔，长度最大64
      }
      chatApi.sendEvaluate(param);
    }
  },

}
</script>

<style scoped>
.eval {
  background: white;
  min-height: 240px;
  width: 100%;
}

.eval_title {
  height: 44px;
  background: #f5f6f9;
  color: #2a2a2c;
  font-size: 14px;
  text-align: left;
  position: relative;
}

.eval_title span {
  margin: 5px 15px;
  display: inline-block;
  line-height: 34px;
  text-align: left;
}

.eval_close {
  position: absolute;
  right: 5px;
  top: 8px;
  font-size: 20px;
  width: 25px;
  color: #999;
  height: 25px;
  margin: 0 !important;
}

.eval_close::before {
  content: "\2716";
}

.eval_body {
  margin: 0 30px 38px;
  text-align: left;
  min-height: 150px;
  position: relative;
  padding-bottom: 64px;
}

.eval_body button {
  position: absolute;
  bottom: 0;
  background: #00A1E2;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  left: 0;
}

.eval_desc {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  margin: 10px;
}

.eval_body .item.active {
  color: white;
  background: #00A1E2;
}

textarea {
  width: 100%;
  height: 100px;
  color: #999999;
  border: .5px solid #bebebe;
  font-size: 14px;
  resize: none;
  padding: 5px;
}

.manual .star {
  display: inline-block;
  width: 50px;
  height: 50px;
  background-image: url("../../../static/image/star.png");
  background-size: 100% 100%;
  cursor: pointer;
}

.manual .star.active {
  background-image: url("../../../static/image/starActive.png");
}

.manual p {
  font-size: 14px;
  color: #00A1E2;
  text-align: center;
  margin: 10px;
}

.star_list {
  margin: 10px auto;
}
.item{
  width: 40vw;
}
.item2 {
  width: 39vw;
  height: 36px;
  display: inline-block;
  border: 0.5px solid #bebebe;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  color: #999999;
  margin-bottom: 20px;
  margin-right: 10px;
}
.plf20{
    padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/h5/evaluate.vue